import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Badge, Dropdown } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { useNavigate } from "react-router-dom";
import { ROUTES, USER_ROLES, USERS_ROLE } from "../../../utilities/constant";
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting";
import "../../../assets/custom/css/custom.css";
import exportData from "../../../utilities/export";
import StatsBar from "./stats-bar";

import { getApiCall, postApiCall } from "../../../service/httpCall";
import { API_VOICE_CAMPAIGNS_LIST, API_VOICE_CAMPAIGNS_UPDATE } from "../../../service/url";
import { useAuth, errorCheck } from "../auth/auth-utils";
import Loader  from '../../../components/partials/components/loader';
import { toast } from 'react-toastify';
import { Storage } from "../../../utilities/setting";


const getTodayStr = () => new Date().toLocaleDateString('en-CA');
const getFirstOfMonthStr = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1).toLocaleDateString('en-CA');
};
const getSixMonthsAgoStr = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 6);
  return d.toLocaleDateString('en-CA');
}; 


const CampaignsList = () => {
  const navigate = useNavigate();
  const [campaigns, setCampaigns] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [showCreateCampaigns, setShowCreateCampaigns] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loggedUserRole, setLoggedUserRole] = useState("");
  const [loggedUserId, setLoggedUserId] = useState(null);
  const [fromDate, setFromDate] = useState(getFirstOfMonthStr());
  const [toDate, setToDate] = useState(getTodayStr());
  const [appliedDates, setAppliedDates] = useState({
  start: getFirstOfMonthStr(),
  end: getTodayStr()
});
  

  const buildDate = (date, isEnd = false) => {
    if (!date) return null;

    const [y, m, d] = date.split("-");

    return new Date(
      y,
      m - 1,
      d,
      isEnd ? 23 : 0,
      isEnd ? 59 : 0,
      isEnd ? 59 : 0,
      isEnd ? 999 : 0
    ).getTime();
  };

  const convertTo24Hour = (time) => {
    if (!time) return "";

    // already 24hr
    if (time.includes(":") && time.length <= 5) return time;

    // convert "07:50 PM" → "19:50"
    const [t, modifier] = time.split(" ");
    let [hours, minutes] = t.split(":");

    if (modifier === "PM" && hours !== "12") {
      hours = String(parseInt(hours, 10) + 12);
    }
    if (modifier === "AM" && hours === "12") {
      hours = "00";
    }

    return `${hours.padStart(2, "0")}:${minutes}`;
  };

   const fetchCampaigns = async (role = loggedUserRole, agentId = loggedUserId,start = fromDate, end = toDate) => {
      setLoading(true);
      let url = API_VOICE_CAMPAIGNS_LIST;

      const queryParams = new URLSearchParams();

      if (role === USER_ROLES.CALL_CENTRE_AGENT && agentId) {queryParams.append("agent_id", agentId);}
      if (start) queryParams.append("start_date", start);
      if (end) queryParams.append("end_date", end);

      const finalUrl = `${url}?${queryParams.toString()}`;
      
      try {
        const res = await getApiCall(finalUrl, {});
        onCampaignListSuccess(res);
      } catch (error) {
        onError(error);
      } finally {
        setLoading(false);
      }
    };


  useEffect(() => {
    const fetchUserDataAndCampaigns = async () => {
      const rawUser = Storage.getItem("user");

      if (!rawUser) {
        console.error("User data not found in Storage");
        return;
      }

      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in Storage user:", e);
        return;
      }

      const role = user?.role;
      setLoggedUserRole(role);

      if (role === USER_ROLES.CALL_CENTRE_ADMIN) {
        setShowCreateCampaigns(true);
      } else {
        setShowCreateCampaigns(false);
      }

      if (role === USER_ROLES.CALL_CENTRE_AGENT) {
        const id = user?.agentData?.id;
        setLoggedUserId(id);
        fetchCampaigns(role, id);
      } else {
        fetchCampaigns(role);
      }
    };


    fetchUserDataAndCampaigns();
  }, []);

  function onCampaignListSuccess(resp) {
    setCampaigns(resp);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
  
    useEffect(() => {
      const user = getUser();
        if (user) {
          if (user?.acl_settings) {    
            setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
          }
        }
    }, []);

  const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "outbound-campaigns",
         data: filteredCampaigns,
         columns: [
            {
               header: "Outbound Campaign",
               accessor: (row) =>
                  row.campaign_name || "-"
            },
            {
               header: "Created On",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            },
            {
               header: "Username",
               accessor: (row) =>
                  row.user?.username || "-"
            },
            {
               header: "Start Date",
               accessor: (row) =>
                  formatDateTime(
                     row.start_date,
                     row.start_hours
                  ).full || "-"
            },
            {
               header: "End Date",
               accessor: (row) =>
                  formatDateTime(
                     row.end_date,
                     row.end_hours
                  ).full || "-"
            },
            {
               header: "Locations",
               accessor: (row) =>
                  row.locations?.length
                     ? row.locations
                        .map(loc => loc.location_name)
                        .join(", ")
                     : "-"
            },
            {
               header: "Template",
               accessor: (row) => {
                  const templateMap = {
                     "0": "Simple IVR",
                     "1": "DTMF",
                     "2": "Call Patch",
                     "3": "Custom IVR"
                  };

                  return templateMap[row.template_id] || "N/A";
               }
            },
            {
               header: "Dialer Type",
               accessor: (row) => {
                  const typeMap = {
                     "1": "Click2Call",
                     "2": "Auto Dialer",
                     "3": "Predictive Dialer",
                     "4": "Power Dialer"
                  };

                  return typeMap[row.campaign_type] || "N/A";
               }
            },
            {
               header: "Total Numbers",
               accessor: (row) =>
                  row.total_members || 0
            },
            {
               header: "Completed",
               accessor: (row) =>
                  row.nos_processed || 0
            },
            {
               header: "Remaining",
               accessor: (row) =>
                  row.total_nos
                     ? Number(row.total_nos) -
                       Number(row.nos_processed || 0)
                     : 0
            },
            {
               header: "Status",
               accessor: (row) =>
                  row.campaign_status || "-"
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};

  const [searchValue, setSearchValue] = useState("");
  const [activeTab, setActiveTab] = useState("all"); // default ALL

  const handleCreateCampaign = () => {
    navigate(`/${ROUTES.CAMPAIGNS.CREATE}`);
  };

  const filteredCampaigns = campaigns.filter((campaign) => {
    const matchesSearch = campaign?.campaign_name
      ?.toLowerCase()
      ?.includes(searchValue.toLowerCase());

    const status = Number(campaign.campaign_status);

    const start = buildDate(appliedDates.start);
    const end = buildDate(appliedDates.end, true);

    const createdAtTs = campaign?.created_at
      ? new Date(campaign.created_at).getTime()
      : null;

    if (start && createdAtTs && createdAtTs < start) return false;
    if (end && createdAtTs && createdAtTs > end) return false;

    if (activeTab === "completed") {
      return matchesSearch && status === 2;
    }

    if (activeTab === "failed") {
      return matchesSearch && [4, 5].includes(status);
    }

    return matchesSearch;
  });

  const statusBodyTemplate = (rowData) => {
    const statusMap = {
      0: { label: "Ready", color: "#37ae00" },
      1: { label: "Running", color: "#218838" },
      2: { label: "Completed", color: "#191cbcff" },
      3: { label: "Low Balance", color: "rgb(206, 185, 0)" },
      4: { label: "Error", color: "#bc1919ff" },
      5: { label: "Error", color: "#bc1919ff" },
      6: { label: "Cancelling", color: "#d07900ff" },
      7: { label: "Cancelled", color: "#be0066ff" },
      8: { label: "Pausing", color: "#138496" },
      9: { label: "Paused", color: "#035fa5ff" },
      10: { label: "Resume", color: "#03cf2fff" },
      21: { label: "DND Processing", color: "#cf5b03ff" },
      22: { label: "Waiting For Ch...", color: "#cf5b03ff" },
    };

    const status = statusMap[rowData.campaign_status];

    return (
      <span
        style={{
          display: "inline-block",
          padding: "0.5em 0.75em",
          fontSize: "0.75em",
          fontWeight: 700,
          lineHeight: 1,
          color: "white",
          textAlign: "center",
          whiteSpace: "nowrap",
          verticalAlign: "middle",
          borderRadius: "0.3rem",
          backgroundColor: status.color,
          minWidth: "85px",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.15)",
          textShadow: "0 1px 1px rgba(0,0,0,0.1)",
        }}
      >
        {status.label}
      </span>
    );
  };

  const actionBodyTemplate = (rowData) => (
    <Dropdown align="end">
      <Dropdown.Toggle variant="link" className="p-0">
        <i className="pi pi-ellipsis-v" />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => handleAction("view", rowData.campaign_id)}>
          <i className="pi pi-pencil me-2" /> View
        </Dropdown.Item>
        {(rowData?.campaign_status == 9  || rowData?.campaign_status == 3) && <Dropdown.Item onClick={() => handleAction("resume", rowData.campaign_id)}>
          <i className="pi pi-pencil me-2" /> Resume
        </Dropdown.Item>}
        {(rowData?.campaign_status == 1) &&
        <Dropdown.Item onClick={() => handleAction("pause", rowData.campaign_id)}>
          <i className="pi pi-pencil me-2" /> Pause
        </Dropdown.Item>}
        {(rowData?.campaign_status == 1) &&
        <Dropdown.Item onClick={() => handleAction("stop", rowData.campaign_id)}>
          <i className="pi pi-pencil me-2" /> Stop
        </Dropdown.Item>}
        {(rowData?.campaign_status == 2 || rowData?.campaign_status == 4 || rowData?.campaign_status == 5 || rowData?.campaign_status == 6 || rowData?.campaign_status == 7) &&
        <Dropdown.Item onClick={() => handleAction("delete", rowData.campaign_id)}>
          <i className="pi pi-pencil me-2" /> Delete
        </Dropdown.Item>}
        <Dropdown.Item onClick={() => handleAction("duplicate", rowData.campaign_id)}>
          <i className="pi pi-pencil me-2" /> Duplicate
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );

  const handleAction = (action, id) => {
    if (action === "view") {
      const url = ROUTES.CAMPAIGNS.DETAIL.replace(":id", id);
      navigate(`/${url}`);
    }
    if (action === "pause") {
      setLoading(true);
      const url = API_VOICE_CAMPAIGNS_UPDATE.replace(":id", id);
      postApiCall(url, { campaign_status: 8 })
        .then(onUpdateSucces)
        .catch(onError)
        .finally(() => setLoading(false))
    }
    if (action === "resume") {
      setLoading(true);
      const url = API_VOICE_CAMPAIGNS_UPDATE.replace(":id", id);
      postApiCall(url, { campaign_status: 10 })
        .then(onUpdateSucces)
        .catch(onError)
        .finally(() => setLoading(false))
    }
    if (action === "stop") {
      setLoading(true);
      const url = API_VOICE_CAMPAIGNS_UPDATE.replace(":id", id);
      postApiCall(url, { campaign_status: 6 })
        .then(onUpdateSucces)
        .catch(onError)
        .finally(() => setLoading(false))
    }
    if (action === "delete") {
      setLoading(true);
      const url = API_VOICE_CAMPAIGNS_UPDATE.replace(":id", id);
      postApiCall(url, { is_deleted: 1 })
        .then(onDeleteSuccess)
        .catch(onError)
        .finally(() => setLoading(false))
    }
    if (action === "duplicate") {
      const url = ROUTES.CAMPAIGNS.DUPLICATE.replace(":duplicate_camp_id", id);
      navigate(`/${url}`);
    }
    console.log(`Action: ${action} on campaign ${id}`);
  };

  async function onUpdateSucces(resp) {
    toast.success("Outbound Campaign Status Updated");
    let url = API_VOICE_CAMPAIGNS_LIST;
    if (loggedUserRole === USER_ROLES.CALL_CENTRE_AGENT && loggedUserId) {
      url += `?agent_id=${loggedUserId}`;
    }
    try {
      const res = await getApiCall(url, {});
      onCampaignListSuccess(res);
    } catch (error) {
      onError(error);
    }
  }

  async function onDeleteSuccess(resp) {
    toast.success("Outbound Campaign Deleted successfully");
    let url = API_VOICE_CAMPAIGNS_LIST;
    if (loggedUserRole === USER_ROLES.CALL_CENTRE_AGENT && loggedUserId) {
      url += `?agent_id=${loggedUserId}`;
    }
    try {
      const res = await getApiCall(url, {});
      onCampaignListSuccess(res);
    } catch (error) {
      onError(error);
    }
  }

  const stats = React.useMemo(() => {
  let total = 0;
  let completed = 0;

  filteredCampaigns.forEach((c) => {
    const totalNos = Number(c.total_members || c.total_nos || 0);
    const done = Number(c.nos_processed || 0);

    total += totalNos;
    completed += done;
  });

  return {
    total,
    completed,
    remaining: total - completed,
  };
}, [filteredCampaigns]);

const formatDateTime = (dateString, timeString) => {
  
  if (!dateString || !timeString) {
    return { full: "Invalid Date", compact: "Invalid Date" };
  }

  const dateTimeStr = `${dateString}T${timeString}`;

  const date = new Date(dateTimeStr);
 
  if (isNaN(date.getTime())) {
    return { full: "Invalid Date", compact: "Invalid Date" };
  }

  const formattedFull = date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const formattedCompact = `${date.toISOString().slice(0, 10)} - ${timeString}`;

  return {
    full: formattedFull,
    compact: formattedCompact,
  };
};

const canRead = hasPermission(
     moduleOperationsForReadPermissionCheck,
     "Campaigns",
     "read",
   );
 
   if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
     return (
       <div
         className="text-center p-4"
         style={{
           marginTop: "50px",
           marginBottom: "50px",
           fontSize: "16px",
         }}
       >
         No read permission found in assigned ACL
       </div>
     );
   }

  if (loading) {
    return <Loader />
  }


  return (
    <>
      {/* <StatsBar /> */}
      <div className="campaigns-container">
        <Row>
          <Col sm="12">
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-0">
                <>
                  <div
                    className="d-flex justify-content-end mt-3 gap-2"
                    style={{ width: "70%", float: "right" }}
                  >
                    {showCreateCampaigns && (
                      <Button
                        label="New Campaign"
                        onClick={() => navigate("/create-campaign")}
                        icon="pi pi-plus"
                        className="p-button-primary"
                      />
                    )}
                    {loggedUserRole !== USER_ROLES.CALL_CENTRE_AGENT &&
                      campaigns.length > 0 && (
                        <Button
                          label="Export Data"
                          icon="pi pi-file-export"
                          onClick={handleExport}
                          className="p-button-active"
                          style={{
                            fontSize: "14px",
                            padding: "0px 8px",
                            marginLeft: "10px",
                            width: "150px",
                            height: "50px",
                          }}
                          disabled={buttonDisable}
                        >
                          &nbsp;
                          {buttonDisable && (
                            <span
                              className="spinner-border spinner-border-sm ml-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          )}
                        </Button>
                      )}
                  </div>
                  <div className="header-title px-1 py-3">
                    <h4 className="card-title">Outbound Campaigns</h4>
                  </div>
                  <Row className="mb-3">
                    <Col md={4}>
                      <Card className="p-3 text-center">
                        <h6>Total Numbers</h6>
                        <h4>{stats.total}</h4>
                      </Card>
                    </Col>

                    <Col md={4}>
                      <Card className="p-3 text-center">
                        <h6>Numbers Processed</h6>
                        <h4 style={{ color: "green" }}>{stats.completed}</h4>
                      </Card>
                    </Col>

                    <Col md={4}>
                      <Card className="p-3 text-center">
                        <h6>Remaining</h6>
                        <h4 style={{ color: "orange" }}>{stats.remaining}</h4>
                      </Card>
                    </Col>
                  </Row>
                  <Row className="mb-4 align-items-end">
                    {/* FROM */}
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>From Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={fromDate}
                          min={getSixMonthsAgoStr()} 
                          max={getTodayStr()}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </Form.Group>
                    </Col>

                    {/* TO */}
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>To Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={toDate}
                          min={fromDate}      
                          max={getTodayStr()}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </Form.Group>
                    </Col>

                    {/* FILTER BUTTON  */}
                     <Col md={2}>
                      <Form.Label style={{ visibility: "hidden" }}>Filter</Form.Label>
                       <Button
                        label="Filter"
                        icon="pi pi-filter"
                        className="w-100 p-button-primary"
                        onClick={() => {
                        fetchCampaigns(loggedUserRole, loggedUserId, fromDate, toDate);
                        setAppliedDates({ start: fromDate, end: toDate });
                        }}
                        />
                      </Col>

                    {/* CLEAR BUTTON */}
                    <Col md={2}>
                      <Form.Label style={{ visibility: "hidden" }}>Clear</Form.Label>
                      <Button
                        label="Clear"
                        className="w-100 p-button-secondary"
                        onClick={() => {
                        const start = getFirstOfMonthStr();
                        const end = getTodayStr();
                        setFromDate(start);
                        setToDate(end);
                        fetchCampaigns(loggedUserRole, loggedUserId, start, end);
      }}
                      />
                    </Col>
                  </Row>
                  <div className="px-4 py-3 d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center flex-wrap">
                      <Form className="d-flex align-items-center">
                        <Form.Control
                          placeholder="Search by name..."
                          type="text"
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          style={{ maxWidth: "250px" }}
                        />
                      </Form>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <div className="btn-group">
                        <Button
                          label="All"
                          onClick={() => setActiveTab("all")}
                          className="campaign-filter-btn"
                          style={
                            activeTab === "all"
                              ? { border: "1px solid purple", backgroundColor: "purple", color: "white", marginRight: "10px" }
                              : { marginRight: "10px" }
                          }
                        />
                        <Button
                          label="Completed"
                          onClick={() => setActiveTab("completed")}
                          className="campaign-filter-btn"
                          style={
                            activeTab === "completed"
                              ? { border: "1px solid purple", backgroundColor: "purple", color: "white", marginRight: "10px" }
                              : { marginRight: "10px" }
                          }
                        />
                        <Button
                          label="Errored / Failed"
                          onClick={() => setActiveTab("failed")}
                          className="campaign-filter-btn"
                          style={
                            activeTab === "failed"
                              ? { border: "1px solid purple", backgroundColor: "purple", color: "white" }
                              : {}
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="pb-4">
                    <div style={{ overflowX: "auto" }} className="broad-scrollbar">
                      <DataTable
                        value={filteredCampaigns}
                        scrollable
                        scrollHeight="flex"
                        tableStyle={{ minWidth: "100%" }}
                        // className="p-datatable-striped p-datatable-gridlines p-datatable-sm"
                        paginator
                        rows={5}
                        //   rowsPerPageOptions={[5, 10, 25]}
                        rowClassName={(rowData) => `${rowData.status} p-3`}
                        className={`${
                      filteredCampaigns.length < 3 && filteredCampaigns.length > 0
                        ? "increasePaddingBottom"
                        : null
                    }`}
                      >
                        <Column
                          field="name"
                          header="Outbound Campaign"
                          sortable
                          style={{ minWidth: "150px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => (
                            <span
                              className="campaign-link"
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                const url = ROUTES.CAMPAIGNS.DETAIL.replace(
                                  ":id",
                                  rowData.campaign_id
                                );
                                navigate(`/${url}`);
                              }}
                            >
                              {rowData.campaign_name}
                            </span>
                          )}
                        />

                        <Column
                          field="created_at"
                          header="Created on"
                          sortable
                          style={{ minWidth: "180px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) =>
                            new Date(rowData.created_at).toLocaleString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                              }
                            )
                          }
                        />
                        <Column
                          field="user.username"
                          header="Username"
                        />
                        <Column
                          field="start_date"
                          header="Start Date"
                          sortable
                          style={{ minWidth: "180px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => {
                            const { full, compact } = formatDateTime(
                              rowData.start_date,
                              rowData.start_hours
                            );
                            return <span className="">{full}</span>;
                          }}
                        />
                        <Column
                          field="end_date"
                          header="End Date"
                          sortable
                          style={{ minWidth: "180px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => {
                            const { full, compact } = formatDateTime(
                              rowData.end_date,
                              rowData.end_hours
                            );
                            return <span className="">{full}</span>;
                          }}
                        />
                        <Column
                          field="locations"
                          header="Dialer Locations"
                          style={{ minWidth: "200px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => {
                            if (!rowData.locations || rowData.locations.length === 0) {
                              return <span>-</span>;
                            }
                            return (
                              <span>
                                {rowData.locations.map((loc) => loc.location_name).join(", ")}
                              </span>
                            );
                          }}
                        />
                        <Column
                          field="template_id"
                          header="Template"
                          sortable
                          style={{ minWidth: "100px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => {
                            const templateMap = {
                              "0": "Simple IVR",
                              "1": "DTMF",
                              "2": "Call Patch",
                              "3": "Custom IVR"
                            };
                            return <span>{templateMap[rowData.template_id] || "N/A"}</span>;
                          }}
                        />
                        <Column
                          field="campaign_type"
                          header="Dialer Type"
                          sortable
                          style={{ minWidth: "100px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => {
                            const typeMap = {
                              "1": "Click2Call",
                              "2": "Auto Dialer",
                              "3": "Predictive Dialer",
                              "4": "Power Dialer"
                            };
                            return <span>{typeMap[rowData.campaign_type] || "N/A"}</span>;
                          }}
                        />
                        <Column
                          field="total_members"
                          header="Total Numbers"
                          sortable
                          style={{ minWidth: "100px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => (
                            <span className="fw-bold">{rowData.total_members}</span>
                          )}
                        />
                        <Column
                          field="nos_processed"
                          header="Completed"
                          sortable
                          style={{ minWidth: "120px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => (
                            <span
                              style={{ color: "#11707d", fontWeight: "bold" }}
                            >
                              {rowData.nos_processed}
                            </span>
                          )}
                        />
                        <Column
                          field="remaining"
                          header="Remaining"
                          sortable
                          style={{ minWidth: "120px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => (
                            <span
                              style={{ color: "#d39e00", fontWeight: "bold" }}
                            >
                              {rowData.total_nos
                                ? rowData.nos_processed &&
                                  Number(rowData.total_nos) -
                                    Number(rowData.nos_processed)
                                : 0}
                            </span>
                          )}
                        />
                        <Column
                          field="campaign_status"
                          header="Status"
                          body={statusBodyTemplate}
                          sortable
                          style={{ minWidth: "120px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                        />
                        <Column
                          header="Actions"
                          body={actionBodyTemplate}
                          style={{ width: "80px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem", textAlign: "center" }}
                        />
                      </DataTable>
                    </div>
                  </div>
                </>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <style>
{`
  .broad-scrollbar::-webkit-scrollbar {
    height: 8px; 
  }
`}
</style>
      </div>
    </>
  );
};

export default CampaignsList;
